import { Injectable } from '@angular/core';
import {
  MonthlyIncome,
  MonthlyExpense,
  LiquidAssets,
  Liabilities,
  Assets,
  LifeInsurance,
  HealthInsurance,
  PersonalAccidentInsurance
} from '../core/checkup';
import { Investor } from '../modules/shared/models/investor';

// export interface ScoreValues {
//   liquidAssets: LiquidAssets;
//   monthlyExpense: MonthlyExpense;
//   totalLiability: Liabilities;
//   totalAssets: Assets;
//   lifeInsuranceAmt: LifeInsurance;
//   healthProtection: HealthInsurance;
//   healthComprehensive: HealthInsurance;
//   accidentalDeath: PersonalAccidentInsurance;
//   pptCoverage: PersonalAccidentInsurance;
//   ttdCoverage: PersonalAccidentInsurance;
//   monthlyIncome: MonthlyIncome;
// }

@Injectable()
export class ScorecardCalcService {
  constructor() {}

  liquidAssets(investor: Investor): number {
    let score = 0;
    const total: number =
      investor.total_liquid_assets_value / investor.total_main_expenditure;
    switch (true) {
      case total >= 6:
        score = 100;
        break;

      case 3 < total && 6 > total:
        score = 50;
        break;

      default:
        score = 0;
        break;
    }
    return score;
  }

  liability(investor: Investor): number {
    let score = 0;
    const total: number =
      investor.total_liabilities_value /
      (investor.total_financial_assets_value +
        investor.total_personal_assets_value +
        investor.total_tangile_assets_value +
        investor.total_liquid_assets_value +
        investor.total_retirement_assets_value +
        investor.total_marketable_assets_value);
    switch (true) {
      case total <= 0.5:
        score = 100;
        break;

      case total <= 0.6:
        score = 90;
        break;

      case total <= 0.7:
        score = 80;
        break;

      case total <= 0.8:
        score = 70;
        break;

      case total <= 0.9:
        score = 60;
        break;

      case total <= 1:
        score = 50;
        break;

      case total <= 1.1:
        score = 40;
        break;

      case total <= 1.2:
        score = 30;
        break;

      case total <= 1.3:
        score = 20;
        break;

      case total <= 1.4:
        score = 10;
        break;

      case total >= 1.5:
        score = 0;
        break;
    }
    return score;
  }
  
  getAge(DOB: Date): number {
    if (DOB) {
      var ageDifMs = Date.now() - DOB.getTime();
      var ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    } else {
      return null;
    }
  }

  retirementAssets(investor: Investor): number {
    let score = 0;
    const yearsToRetirement = investor.retirement_age - this.getAge(new Date(investor.DOB));
    const requiredSavings = (investor.total_main_expenditure * 12) * (Math.pow(1.07, yearsToRetirement) * 25);
    score = investor.total_retirement_assets_value * 100 / requiredSavings;
    return score;
  }

  lifeInsurance(investor: Investor): number {
    if (
      investor.insurances['life_insurance'][0].existing_value * 15 >=
      investor.total_main_income * 12
    ) {
      console.log('li', 100);
      return 100;
    } else {
      console.log('li', 0);
      return 0;
    }
  }

  healthProtection(investor: Investor): number {
    if (
      investor.total_main_income * 12 * 0.6 <=
      investor.insurances['health_insurance'][0].existing_value
    ) {
      return 100;
    } else {
      return 0;
    }
  }

  healthComprehensive(investor: Investor): number {
    if (
      investor.total_main_income * 12 <=
      investor.insurances['health_insurance'][1].existing_value
    ) {
      return 100;
    } else {
      return 0;
    }
  }

  healthInsurance(investor: Investor): number {
    return (
      this.healthProtection(investor) * 0.5 +
      this.healthComprehensive(investor) * 0.5
    );
  }

  accidentalDeath(investor: Investor): number {
    if (
      investor.insurances['personal_accident_insurance'][0].existing_value *
        75 >=
      investor.total_main_income
    ) {
      return 100;
    } else {
      return 0;
    }
  }

  pptCoverage(investor: Investor): number {
    if (
      investor.insurances['personal_accident_insurance'][1].existing_value *
        60 >=
      investor.total_main_income
    ) {
      return 100;
    } else {
      return 0;
    }
  }

  ttdCoverage(investor: Investor): number {
    if (
      investor.total_main_income <=
      investor.insurances['personal_accident_insurance'][2].existing_value
    ) {
      return 100;
    } else {
      return 0;
    }
  }

  personalAccidentInsurance(investor: Investor): number {
    return (
      this.accidentalDeath(investor) * 0.33 +
      this.pptCoverage(investor) * 0.33 +
      this.ttdCoverage(investor) * 0.33
    );
  }

  insurance(investor: Investor): number {
    return (
      this.lifeInsurance(investor) * 0.33 +
      this.healthInsurance(investor) * 0.33 +
      this.personalAccidentInsurance(investor) * 0.33
    );
  }

  getScore(investor: Investor): number {
    console.log('liquid', this.liquidAssets(investor));
    console.log('liability', this.liability(investor));
    console.log('retirementAssets', this.retirementAssets(investor));
    console.log('insurance', this.insurance(investor));
    return Math.round (
      this.liquidAssets(investor) * 0.2 +
      this.liability(investor) * 0.1 +
      this.retirementAssets(investor) * 0.2 +
      this.insurance(investor) * 0.3 +
      100 * 0.2
    );
  }

  getScoreCard(score: number): string {
    switch (true) {
      case score <= 40:
        return 'good';

      case score > 40 && score < 70:
        return 'very good';

      case score >= 70:
        return 'excellent';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/scorecard-calc.service.ts